import { render } from "./Q19-End.vue?vue&type=template&id=8d6fd064&scoped=true"
import script from "./Q19-End.vue?vue&type=script&lang=js"
export * from "./Q19-End.vue?vue&type=script&lang=js"

import "./Q19-End.vue?vue&type=style&index=0&id=8d6fd064&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d6fd064"]])

export default __exports__